import React, { useEffect, useState, useCallback } from "react";
import { HTTP } from "../../http/http-common";
import styled from "styled-components";

const ProfileImage = ({ src, alt }) => (
  <img className="profile-image" src={src} alt={alt} />
);

const GeneralContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 20px;
`;

const ProfileInfo = ({ name, email }) => (
  <div className="profile-info">
    <div className="info-row">
      <div className="info-label">Name:</div>
      <div className="info-value">{name}</div>
    </div>
    <div className="info-row">
      <div className="info-label">E-mail:</div>
      <div className="info-value">{email}</div>
    </div>
  </div>
);

function Account() {
  const [profileData, setProfileData] = useState({});

  const fetchUser = useCallback(() => {
    HTTP.request("user", { withCredentials: true })
      .then((res) => {
        if (res.data.result) setProfileData(res.data.response);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <>
      <GeneralContainer className="profile-container">
        <section className="profile-section">
          <header className="profile-header">
            <h2 className="profile-title">My profile</h2>
          </header>
          <div className="profile-content">
            <ProfileImage
              src={profileData.image_src}
              alt={profileData.image_alt}
            />
            <ProfileInfo
              name={
                profileData.email && profileData.email.includes("@")
                  ? profileData.email.split("@")[0]
                  : profileData.email
              }
              email={profileData.email}
            />
          </div>
        </section>
      </GeneralContainer>

      <style jsx>{`
        /* Global box-sizing to include padding in width calculations */
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        .profile-container {
          display: flex;
          flex-direction: row;
          width: 100%;
          height: 100%;
          overflow-x: auto;
        }

        .profile-container {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .profile-container::-webkit-scrollbar {
          display: none;
        }

        @media (max-width: 991px) {
          .profile-container {
            flex-direction: column;
            align-items: stretch;
            gap: 0;
          }
        }

        .profile-section {
          border-radius: 20px;
          background: linear-gradient(360deg, #2c3139 -2.06%, #16181d 102.08%);
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 30px;
        }

        @media (max-width: 991px) {
          .profile-section {
            margin-top: 25px;
            padding: 20px;
          }
        }

        .profile-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;
        }

        .profile-title {
          color: var(--Text-Light, #e7e7e7);
          font: 600 22px Inter, sans-serif;
        }

        .profile-content {
          display: flex;
          gap: 50px;
          font-size: 16px;
          color: var(--Text-Medium, #7b7b7b);
          font-weight: 400;
        }

        @media (max-width: 991px) {
          .profile-content {
            flex-direction: column;
            gap: 20px;
          }
        }

        .profile-image {
          width: 75px;
          box-shadow: 0 10.714px 42.857px 0 rgba(49, 188, 192, 0.5);
          align-self: start;
          flex-shrink: 0;
        }

        .profile-info {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
          flex: 1;
          padding: 0 16px 11px 0;
        }

        .info-row {
          margin-top: 23px;
        }

        .info-label {
          font-family: Inter, sans-serif;
        }

        .info-value {
          color: var(--Text-Light, #e7e7e7);
          margin-top: 16px;
          font: 14px Poppins, sans-serif;
        }
      `}</style>
    </>
  );
}

export default Account;
